module.exports = __webpack_public_path__ + "img/anonymous.5153aff8.png";